import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';

import {BaseService} from '../base/base.service';
import {ItemGroup} from '../../models/lookups/item-group';
import {Item} from '../../models/lookups/item';
import {WebUser} from '../../models/web-user';
import {Query} from '../../models/query/query';
import {City} from '../../models/lookups/city';
import {Document} from '../../models/document/document';
import {AppModulePath} from '../../models/app-module-path';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class WebService extends BaseService {
  private listItemGroupUrl = '/api/web/listItemGroups';
  private listUrl = '/api/web/list';
  private registerUrl = '/api/web/register';
  private loginUrl = '/api/web/login';
  private getImagesUrl = '/api/items/getImages';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  listItemGroup(qry: Query): Observable<ItemGroup[]> {
    return this.post<ItemGroup[]>(this.listItemGroupUrl, AppModulePath.ITEM_GROUP, qry).pipe(
      map(res => res.map(obj => new ItemGroup(obj))),
      catchError(this.handleError));
  }

  listItems(qry: Query): Observable<any[]> {
    return this.post<any[]>(this.listUrl, AppModulePath.ITEM, qry).pipe(
      map(res => res.map(obj => new Item(obj))),
      catchError(this.handleError));
  }

  listCities(qry: Query): Observable<City[]> {
    return this.post<City[]>('/api/web/listCities', AppModulePath.CITY, qry).pipe(
      map(res => res.map(obj => new City(obj))),
      catchError(this.handleError));
  }

  listcustomers(qry: Query): Observable<WebUser[]> {
    return this.post<WebUser[]>('/api/web/listCustomers', AppModulePath.CITY, qry).pipe(
      map(res => res.map(obj => new WebUser(obj))),
      catchError(this.handleError));
  }

  register(user: WebUser): Observable<WebUser> {
    return this.post<WebUser>(this.registerUrl, AppModulePath.ITEM, user).pipe(
      map(res => new WebUser(res)),
      catchError(this.handleError));
  }

  login(user: WebUser): Observable<WebUser> {
    return this.post<WebUser>(this.loginUrl, AppModulePath.ITEM, user).pipe(
      map(res => new WebUser(res)),
      catchError(this.handleError));
  }

  requestPassword(email: string) {
    return this.post('/api/web/forgottenPassword', AppModulePath.ITEM, email);
  }

  saveDocument(document: Document): Observable<Document> {
    return this.post<Document>('/api/document/save', AppModulePath.DOCUMENT, document).pipe(
      map(res => new Document(res)),
      catchError(this.handleError));
  }

  getImagesNumber(id: any): Observable<number> {
    return this.post<number>(this.getImagesUrl, AppModulePath.ITEM, id).pipe(
      map(res => res),
      catchError(this.handleError));
  }
}
